import './accordion';
import './blog';
import './brands';
import './dimmer';
import './isotope';
import './lasktop-nav';
import './phablet';
import './services';
import './tab';
import './sliders';
import './testimonials';